var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function FlashSolid(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M15.378 5.957a.545.545 0 0 0-.485-.273H9.867L12.69.686a.426.426 0 0 0-.022-.46.555.555 0 0 0-.453-.226H7.929a.545.545 0 0 0-.484.271L2.623 9.27a.426.426 0 0 0 .031.456c.098.137.269.22.453.22h4.399l-3.82 7.398c-.102.216-.009.466.218.588.227.121.52.077.689-.103L15.304 6.461a.431.431 0 0 0 .074-.504z" }) })));
}
export default FlashSolid;
